module.exports = __webpack_public_path__ + "static/media/50.328366b2.png";